import React from 'react';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import Chevron from '../Chevron';
import SkillDropDown from './SkillDropDown';

export class SkillInfoValueBar extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      displayDropdown: false,
    };
  }

  barFilledStyle = {
    width: `${this.props.skillValue * 10}%`,
    backgroundColor: this.props.tenant.secondary,
  };

  updateDropDown = () => {
    const { displayDropdown } = this.state;
    this.setState({
      displayDropdown: !displayDropdown,
    });
  };

  rotateCaret = {
    transform: 'rotate(180deg)',
  };

  render() {
    const { displayDropdown } = this.state;
    return (
      <Translation>
        {(t) => (
          <div id="skill-info-value-bar" className="skill-info-value-bar">
            <div className="skill-info-value-bar__row-with-skill-bar">
              <div className="skill-info-value-bar__title-container">
                <p className="skill-info-value-bar__skill-title">
                  {this.props.skillTitle}
                </p>
                <button
                  type="button"
                  tabIndex={0}
                  className="skill-info-value-bar__view-more"
                  style={{ color: this.props.tenant.primary }}
                  onClick={() => {
                    this.updateDropDown();
                  }}
                >
                  {displayDropdown ? t('View less') : t('View more')}
                </button>
              </div>
              <div className="skill-info-value-bar__bar-caret-container">
                <div className="skill-info-value-bar__skill-full-bar">
                  <div
                    className="skill-info-value-bar__skill-bar-filled"
                    style={this.barFilledStyle}
                  >
                    <div
                      role="img"
                      className="skill-info-value-bar__skill-value"
                      style={{ backgroundColor: this.props.tenant.secondary }}
                      aria-label={`This career utilizes the communication skill at a level ${this.props.skillValue} on a scale of 1 to 10.`}
                    >
                      {this.props.skillValue}
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  tabIndex={0}
                  onClick={this.updateDropDown}
                  className="skill-info-value-bar__caret-button"
                  style={displayDropdown ? this.rotateCaret : null}
                >
                  <Chevron
                    color="#D0D0D0"
                    ariaLabel={`${
                      displayDropdown
                        ? 'Click to close additional information about this skill'
                        : 'Click to view additional information about this skill'
                    }`}
                  />
                </button>
              </div>
            </div>
            {displayDropdown ? (
              <SkillDropDown
                description={this.props.description}
                skillTitle={this.props.skillTitle}
                courses={this.props.courses}
                carouselClassName={this.props.carouselClassName}
              />
            ) : null}
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = state.tenant;
  return { tenant };
};

export default connect(mapStateToProps)(SkillInfoValueBar);
